module.exports = __webpack_public_path__ + "db48c376bc2c035efa78b77bd348c338.html";


//////////////////
// WEBPACK FOOTER
// ./src/portal/components/info-sharing-accounts/info-sharing-accounts-de.html
// module id = 931
// module chunks = 0